module.exports = __webpack_public_path__ + "img/stripe-wordmark-slate.347726fa.svg";